import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import firebase  from 'firebase';


const database=firebase.database();


class VehiculosBases extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			vehiculos:[]
	
		}
		
		this.vehiculosRef=database.ref().child('Vehiculos').orderByChild('base').equalTo(this.props.match.params.base);
	}
	
	
	componentDidMount(){
				
		this.vehiculosRef.on('value', this.gotData, this.errData);
				
	}
	
	
	gotData = (data) => {
		
		  let nombre_socio='';
		  let nombre_base='';
		  let newVehiculo = [];
		  const vehiculodata = data.val();


		  
		  if(vehiculodata!=null){
			  
		  const keys = Object.keys(vehiculodata);
		  
		  for (let i = 0; i < keys.length; i++) {
			const k = keys[i];
			
				newVehiculo.push({
				  key:k,
				  anio:vehiculodata[k].anio,
				  capacidad:vehiculodata[k].capacidad,
				  codigo_socio:vehiculodata[k].codigo_socio,
				  disponibilidad:vehiculodata[k].disponibilidad,
				  estado:vehiculodata[k].estado,
				  foto:vehiculodata[k].foto,
				  marca:vehiculodata[k].marca,
				  modelo:vehiculodata[k].modelo,
				  placa:vehiculodata[k].placa,
				  tipo:vehiculodata[k].tipo_vehiculo,
				  base:vehiculodata[k].base,
				  
				});
			  }
			  this.setState({vehiculos: newVehiculo});  
			  
			  
		  }
		  
		}
		errData = (err) => {
	      console.log(err);
	    }
	
	
	render(){
		
		return(
		
		
			<div className="vehiculos_bases container">
		
					<h1 className="titulo">{this.props.match.params.nombre}</h1>
					
					
					
					
					<Link to="/bases"><span className="glyphicon glyphicon-arrow-left"> </span> Bases</Link>
						<BootstrapTable data={ this.state.vehiculos }
							 ref='table'			 
							 pagination={ true }
							 search={ true }
							 hover
							 >
							 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							 <TableHeaderColumn dataField='marca' dataSort={true}>Marca</TableHeaderColumn>
							 <TableHeaderColumn dataField='modelo' dataSort={true}>Modelo</TableHeaderColumn>
							 <TableHeaderColumn dataField='placa'>Placa</TableHeaderColumn>
							 <TableHeaderColumn dataField='capacidad' >Capacidad</TableHeaderColumn>
							 <TableHeaderColumn dataField='anio' >Año</TableHeaderColumn>
							 <TableHeaderColumn dataField='estado' >Estado</TableHeaderColumn>
							 
						
						</BootstrapTable>
			
			</div>
		
		);
	}
}


export default VehiculosBases;


// WEBPACK FOOTER //
// ./src/Components/Vehiculos_Bases/VehiculosBases.js